import React from 'react'
import "./SubStyle.css"

const Soft_Governance = () => {
  return (
     <section className="SubServices">
     <h1 className="SubServices-title">Governance Software</h1>
      <p className="SubServices-pera">Strengthen compliance and operational oversight with our comprehensive governance platform. Monitor performance, manage policies, track actions, and maintain clear accountability across your organisation, helping you meet regulatory requirements with confidence.</p>
         <div className="btn-container">
        <button className="SubServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Soft_Governance
